import { BaseContainerModel } from "../../base-container.model";
import { bl_fi_generic_doc_custom_processing_queue_RowClass } from "../../../dbschema";

export class GenericDocCustomProcessingQueueContainerModel extends BaseContainerModel{
  bl_fi_generic_doc_custom_processing_queue: bl_fi_generic_doc_custom_processing_queue_RowClass = new bl_fi_generic_doc_custom_processing_queue_RowClass();
}